/**
 * Latest WebSocket `connectGeneration` from {@link GlobalRealtimeProvider} connect loop.
 * Used only for iOS WebRTC call-drop diagnostics ([CALL END] logs).
 */
export const wsConnectGenerationProbe = { current: 0 };
